const mainMenu = function () {
    var isMenuOpen = false;
    var isMobile = null;
    const menuBurger = document.querySelector('.hamburger');
    const menuHolder = document.querySelector('.site-header__bottom');
    const menuDropdown = document.querySelectorAll('.site-header__bottom li.menu-item-has-children > a');



    if (window.innerWidth < 1024) {
        isMobile = true;
    } else {
        isMobile = false;
    }
    
    window.addEventListener("resize", () => {
        if (window.innerWidth < 1024) {
            isMobile = true;
        } else {
            isMobile = false;
        }

        menuDropdown.forEach((menu) => {
            resetStyles(menu.nextElementSibling);
        });

        closeMenu();
    });

    menuDropdown.forEach((menu) => {
        menu.addEventListener("click", (e) => {
            e.preventDefault;
            if (isMobile) {
                slideToggle(menu.nextElementSibling, 500);
            }
        }, false);
    });

    menuBurger.addEventListener("click", () => {
        if (isMenuOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    }, false);

    const openMenu = () => {
        isMenuOpen = true;
        menuBurger.classList.add('is-active');
        menuHolder.classList.add('is-active');
    }

    const closeMenu = () => {
        isMenuOpen = false;
        menuBurger.classList.remove('is-active');
        menuHolder.classList.remove('is-active');
    }

    /* SLIDE UP */
    let slideUp = (target, duration = 500) => {

        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    /* SLIDE DOWN */
    let slideDown = (target, duration = 500) => {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;
        if (display === 'none') display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    /* TOOGLE */
    var slideToggle = (target, duration = 500) => {
        if (window.getComputedStyle(target).display === 'none') {
            return slideDown(target, duration);
        } else {
            return slideUp(target, duration);
        }
    }

    const resetStyles = (item) => {
        item.attributeStyleMap.clear()
    }

    // slideUp(document.getElementById("target"), 1000);

    // slideDown(document.getElementById("target"), 1000);

}

export const init = mainMenu;